import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import holdImage from "../../assests/images/hold.png";
import rejectImage from "../../assests/images/Reject.png";
import releasedImage from "../../assests/images/Release.png";
import podetailImage from "../../assests/images/Po details.png";
import summaryImage from "../../assests/images/Summary.png";
import checkImage from "../../assests/images/check-circle.png";
import { UserObj } from "../../services/localStarage";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import SupportChat from "../support/chat";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const extendvaliditystyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created By : Sanjeev`,
    remarks: `Remarks : Approved`,
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
  {
    label: "ASN Creation",
    text: "ASN Created on : 12-02-2024",
    description: `ASN Created By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
  {
    label: "ASN Approval",
    text: "ASN Approved on : 12-02-2024",
    description: `ASN Approved By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
  {
    label: "First QC Status",
    text: "1st QC Status on : 12-02-2024",
    description: `1st QC Status By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
  {
    label: "2nd QC Status",
    text: "2nd QC Status on : 12-02-2024",
    description: `2nd QC Status By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
  {
    label: "Dispatch Status",
    text: "Dispatch Status on : 12-02-2024",
    description: `Dispatch Status By : Sanjeev`,
    remarks: `Remarks`,
  },
  {
    label: "Gate Entry",
    text: "Gate Entry on : 12-02-2024",
    description: `Gate Entry By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
  {
    label: "GRC",
    text: "GRC on : 12-02-2024",
    description: `GRC By : Sanjeev`,
    remarks: `Remarks : Pending`,
  },
];
function PoDetail() {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const [openextendvalidityremarksmodal, setOpenExtendValidityRemarksModal] =
    useState(false);

  const handleReset = () => {
    setActiveStep(0);
  };
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [openapprovepurchasetModal, setOpenApprovePurchaseModal] =
    useState(false);
  const [openapprovesucessfullyModal, setOpenApproveSucessfullyModal] =
    useState(false);
  const [openholdModal, setOpenHoldModal] = useState(false);
  const [openholdsucessfullyModal, setOpenHoldSucessfullyModal] =
    useState(false);
  const [openrejectedModal, setOpenRejectedModal] = useState(false);
  const [openrejectedsucessfullyModal, setOpenRejectedSuccessfullyModal] =
    useState(false);
  const [openrreleasedModal, setOpenReleasedModal] = useState(false);
  const [openrreleasedsuccessfullyModal, setOpenReleasedSuccessfullyModal] =
    useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const userRole = UserObj ? UserObj?.role?.name : "";
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  const DrawerList = (
    <Box
      sx={{
        width: 350,
        zIndex: 1300,
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <List>
        <div className="row_order_sidebar_bdpt_po_div">
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">UserName</h6>
              <p className="username_bpdt_div_react_row1">Suntech Solution</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Status</h6>
              <p class="date_solutions_status_row">Pending</p>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">Date Stamp</h6>
              <p className="username_bpdt_div_react_row1">12-02-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Target Date</h6>
              <p className="username_bpdt_div_react_row1">12-02-2024</p>
            </div>
          </div>
        </div>
      </List>
      <Divider />
      <List>
        <div>
          <Box
            className="po_detail_bfdt_row_div_sidebar1"
            sx={{ maxWidth: 400 }}
          >
            <Stepper orientation="vertical">
              {steps.map((step, index) => (
                <Step key={index} expanded>
                  <StepLabel>{step.label}</StepLabel>
                  <StepContent>
                    <Typography>{step.description}</Typography>
                    {step.text && (
                      <Typography sx={{ mt: 1 }}>{step.text}</Typography>
                    )}
                    {step.remarks && (
                      <Typography sx={{ mt: 1 }}>{step.remarks}</Typography>
                    )}
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
      </List>
    </Box>
  );

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>PO Details</h5>
            </div>

            <div className="create_listing_project">
              <div>
                <button
                  className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <LayersIcon />
                  Action
                </button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenApprovePurchaseModal}>
                      Approve
                    </MenuItem>
                  ) : null}

                  {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenHoldModal}>Hold</MenuItem>
                  ) : null}
                  {userRole === "BUYER" ? (
                    <MenuItem onClick={setOpenRejectedModal}>Reject</MenuItem>
                  ) : null}
                  {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenReleasedModal}>Release</MenuItem>
                  ) : null}
                  {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenExtendValidityRemarksModal}>
                      Extend Validity
                    </MenuItem>
                  ) : null}
                </Menu>
              </div>
              <div className="track_order_react_row">
                <button
                  onClick={toggleDrawer(true)}
                  class="vendor_btn vendor_maine_contents"
                >
                  Track Order
                </button>

                <Drawer
                  anchor="right"
                  open={state.open}
                  onClose={toggleDrawer(false)}
                  style={{ zIndex: 99999 }}
                >
                  {DrawerList}
                </Drawer>
              </div>

              <div>
                <button
                  className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                  id="basic-button"
                  aria-controls={download ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={download ? "true" : undefined}
                  onClick={handleClicks}
                >
                  <FileDownloadIcon />
                  Download
                </button>
                <Menu
                  id="basic-menu"
                  anchorEl={downloadEl}
                  open={download}
                  onClose={handleCloses}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={handleCloses}>
                      Header Level Excel
                    </MenuItem>
                  ) : null}
                  {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={handleCloses}>
                      Line Item Level Excel
                    </MenuItem>
                  ) : null}
                  {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenPoPdfPurchaseModal}>
                      PO PDF
                    </MenuItem>
                  ) : null}
                </Menu>
              </div>
            </div>
          </div>

          <div className="lets_head_purchase_number_buyer_react_blocklist">
            <div className="first_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={podetailImage} alt="" />
                  <p className="lets_block_react_details_purchase">
                    PO Number : 00701
                  </p>
                </div>
                <div className="lets_pending_react_body">
                  Order Date :
                  <span className="date_solutions"> 19-04-2024 </span>
                  <div className="solution_asen_statsu_pending">
                    Status :<p className="date_solutions_status">Pending</p>
                  </div>
                </div>
              </div>

              <div className="lets_table_buyername_react_suntech">
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      SAP PO Number
                    </td>
                    <td>:</td>
                    <td>12345</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Number
                    </td>
                    <td>:</td>
                    <td>00281</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Name
                    </td>
                    <td>:</td>
                    <td>Orance Pvt. Ltd.</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      PO Type
                    </td>
                    <td>:</td>
                    <td>Supply</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">Buyer</td>
                    <td>:</td>
                    <td>Suntech Solutions</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Company Code
                    </td>
                    <td>:</td>
                    <td>68GHP89</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Purchase Organisation
                    </td>
                    <td>:</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Purchase Group
                    </td>
                    <td>:</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Payment Terms
                    </td>
                    <td>:</td>
                    <td>Net 30</td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Project Name
                    </td>
                    <td>:</td>
                    <td>Solar Project</td>
                  </tr>
                  <tr>
                    <td>Package Name</td>
                    <td>:</td>
                    <td>Solar Module Supply</td>
                  </tr>
                  <tr>
                    <td>Contact Person Email</td>
                    <td>:</td>
                    <td>deepak.kumar@gmail.com</td>
                  </tr>
                  <tr>
                    <td>Contact Person Name</td>
                    <td>:</td>
                    <td>Deepk Kumar</td>
                  </tr>
                  <tr>
                    <td>Contact Person Number</td>
                    <td>:</td>
                    <td>9718871734</td>
                  </tr>
                  <tr>
                    <td>Total Quantity</td>
                    <td>:</td>
                    <td>1,200</td>
                  </tr>
                  <tr>
                    <td>Received Quantity</td>
                    <td>:</td>
                    <td>800</td>
                  </tr>
                  <tr>
                    <td>Pending Quantity</td>
                    <td>:</td>
                    <td>400</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="second_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={summaryImage} alt="" />
                  <p className="lets_block_react_details_purchase">Summary</p>
                </div>
              </div>
              <div className="lets_table_buyername_react_suntech">
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Gross Amount
                    </td>
                    <td>:</td>
                    <td>₹10,00,000</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">Tax</td>
                    <td>:</td>
                    <td>₹1,80,000</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">Freight</td>
                    <td>:</td>
                    <td>₹20,000</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">Discount</td>
                    <td>:</td>
                    <td>₹40,000</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Net Value
                    </td>
                    <td>:</td>
                    <td>₹9,60,000</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div className="listing_main" style={{ overflowX: "scroll" }}>
            <table>
              <thead>
                <tr>
                  <th className="vendor_tabels">
                    {/* <input type="checkbox" /> */}
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Material Number</p>

                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Material Description</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Unit of Measurement</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels" colSpan={2}>
                    <div className="PoDetailTableHeading">
                      <p style={{ textAlign: "center" }}>PO Quantity</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2rem",
                        }}
                      >
                        <p>Boxes</p>
                        <p>Pcs</p>
                      </div>
                    </div>
                    <img src="images/code.png" alt="" />
                  </th>
                  <th className="vendor_tabels" colSpan={2}>
                    <div className="PoDetailTableHeading">
                      <p style={{ textAlign: "center" }}>Received Quantity</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2rem",
                        }}
                      >
                        <p>Boxes</p>
                        <p>Pcs</p>
                      </div>
                    </div>
                    <img src="images/code.png" alt="" />
                  </th>
                  <th className="vendor_tabels" colSpan={2}>
                    <div className="PoDetailTableHeading">
                      <p style={{ textAlign: "center" }}>Pending Quantity</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2rem",
                        }}
                      >
                        <p>Case(s) </p>
                        <p>Pcs</p>
                      </div>
                    </div>
                    <img src="images/code.png" alt="" />
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Plant Name</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Net Price</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Net order value</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Purchase Requisition</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>HSN Code</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                  <th className="vendor_tabels ">
                    <div className="PoDetailTableHeading">
                      <p>Delivery Date</p>
                      <input
                        type="text"
                        class="form-control form-ha"
                        placeholder="Search"
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>

                  <td className="block_solar">43245</td>
                  <td>Steel Rods</td>
                  <td>Ton</td>
                  <td>5</td>
                  <td>2</td>
                  <td>5</td>
                  <td>2</td>
                  <td>5</td>
                  <td>2</td>
                  <td>Mumbai Plant</td>
                  <td>₹ 50,000</td>
                  <td>₹ 50,00,000</td>
                  <td>PRQ2001</td>
                  <td>7207</td>
                  <td>12-07-2024</td>
                </tr>
                <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>

                  <td className="block_solar">76543</td>
                  <td>Copper Wire</td>
                  <td>Kg</td>
                  <td>2</td>
                  <td>3</td>
                  <td>2</td>
                  <td>3</td>
                  <td>2</td>
                  <td>3</td>
                  <td>Pune Plant</td>
                  <td>₹ 40,000</td>
                  <td>₹ 40,00,000</td>
                  <td>PRQ2002</td>
                  <td>7408</td>
                  <td>11-07-2024</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Approve Modal Buyer Po */}
          {userRole === "MANAGER" ? (
            <Modal
              open={openapprovepurchasetModal}
              onClose={() => setOpenApprovePurchaseModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApprovePurchaseModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_manager_bidding">
                    Are you sure you want to "<b>Approve</b>" selected purchase
                    order? PO No. :<b>00701</b> | PO Amount : <b>₹35,600</b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenApprovePurchaseModal(false);
                        setOpenApproveSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenApprovePurchaseModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Approve sucessfully Modal  */}
          {userRole === "MANAGER" ? (
            <Modal
              open={openapprovesucessfullyModal}
              onClose={() => setOpenApproveSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApproveSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Approved</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenApproveSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Hold Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openholdModal}
              onClose={() => setOpenHoldModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHoldModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_manager_bidding">
                    Are you sure you want to "<b>Hold</b>" selected purchase
                    order?
                  </p>
                  <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHoldModal(false);
                        setOpenHoldSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenHoldModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Hold sucessfully Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openholdsucessfullyModal}
              onClose={() => setOpenHoldSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHoldSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={holdImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Hold</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenHoldSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}

          {/* Rejected Modal  */}
          {userRole === "BUYER" ? (
            <Modal
              open={openrejectedModal}
              onClose={() => setOpenRejectedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRejectedModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_manager_bidding">
                    Are you sure you want to "<b>Reject</b>" selected purchase
                    order?
                  </p>
                  <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenRejectedModal(false);
                        setOpenRejectedSuccessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenRejectedModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Reject sucessfully Modal  */}
          {userRole === "BUYER" ? (
            <Modal
              open={openrejectedsucessfullyModal}
              onClose={() => setOpenRejectedSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRejectedSuccessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={rejectImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Reject</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenRejectedSuccessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}

          {/* Released  Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openrreleasedModal}
              onClose={() => setOpenReleasedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenReleasedModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={releasedImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Released</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => {
                          setOpenReleasedModal(false);
                          setOpenReleasedSuccessfullyModal(true);
                        }}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Released Successfully  Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openrreleasedsuccessfullyModal}
              onClose={() => setOpenReleasedSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenReleasedSuccessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" />
                      <p className="profile_react_block">
                        All selected PO have been updated successfully.
                      </p>
                      <p className="profile_react_blocks">
                        Total PO Selected. : <b>15 |</b> PO Updated :<b>15</b>
                      </p>
                      <p className="profile_react_blocks">
                        PO Total Amount : <b>₹35,600 |</b> PO Total Qty :{" "}
                        <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenReleasedSuccessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* PO PDF Modal Buyer Po */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openpopdfpurchasemodal}
              onClose={() => setOpenPoPdfPurchaseModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenPoPdfPurchaseModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download PO Pdf
                    <br />
                    <b>PO No. : 00701 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenPoPdfPurchaseModal(false);
                        setOpenPoPdfPurchaseSuccessModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => {
                        setOpenPoPdfPurchaseModal(false);
                        setOpenPoPdfPurchaseRejectedModal(true);
                      }}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* PO PDF Successfully Modal Buyer Po */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openpopdfpurchasesuccessmodal}
              onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected PO has been "<b>PDF Download</b>" Successfully
                    <br />
                    <b>PO No. : 07001 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenPoPdfPurchaseSuccessModal(false);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/*Extend Validity PO Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openextendvalidityremarksmodal}
              onClose={() => setOpenExtendValidityRemarksModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={extendvaliditystyle1}
                className="modal_react_controlpanel_employees"
              >
                <div className="modal-headeres">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Extend Validity
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenExtendValidityRemarksModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="listing_main"
                    style={{
                      overflowY: "scroll",
                      height: "40vh",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th
                            colSpan={1}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>PO No.</p>
                          </th>
                          <th
                            colSpan={2}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>Current Validity</p>
                          </th>
                          <th
                            colSpan={2}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>New Validity</p>
                          </th>
                          <th
                            colSpan={1}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <div className="remarks_bdbt_div_react_validity">
                              <p>
                                Remarks <span className="error">*</span>{" "}
                              </p>
                              <ContentCopyIcon />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00701
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-01-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00702
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00703
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00704
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-05-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00705
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00706
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00707
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00708
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-09-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="table_btn_failed_sucess_purchase">
                    <button
                      onClick={() => setOpenExtendValidityRemarksModal(false)}
                      className="view_success"
                    >
                      Discard
                    </button>
                    <button
                      onClick={() => setOpenExtendValidityRemarksModal(false)}
                      className="view_failed"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}

          {/*Extend Validity PO Modal  */}
        </div>
        <SupportChat
          vendorDetails={{ vendor: { _id: "667bb2852cf8382719badf09" } }}
        />
      </div>
    </>
  );
}

export default PoDetail;
